// extracted by mini-css-extract-plugin
module.exports = {"container":"_40d5d0e87d--container--ReagZ","crumb":"_40d5d0e87d--crumb--qD0ek","arrow":"_40d5d0e87d--arrow--FxKxR"};